import { useState, type ReactNode } from "react";
import AdminUsers from "../admin-users/AdminUsers";
import AdminColumns from "../../components/admin-columns/AdminColumns";
import { AdminLogs } from "../admin-logs/AdminLogs";
import Sidebar from "@/components/sidebar/Sidebar";
import "./admin.css"
import type { IconName } from "@/components/icon/IconName";
import { Outlet, useLocation, useNavigate } from "react-router-dom";


export default function Admin({
  children,
}: {
  children: React.ReactNode;
}) {

  type TabType = {
   
    id: string;
    label: string; 
    icon: IconName;
    path: string;
  }

  const location = useLocation(); 

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(location.pathname);
  const tabs = [
    {
      id: "/admin/users",
      label: "Utilisateurs",
      icon: "user",
      path: "/admin/users"
    },
    {
      id: "/admin/logs",
      label: "Logs",
      icon: "document",
      path: "/admin/logs"
    },
  ] as TabType[];

  const onChange = (tab: TabType) => {
    setActiveTab(tab.id)
    navigate(tab.path);
  }


  return (
    <div className="admin-layout">
      <Sidebar  
        activeTab={activeTab}
        tabs={tabs}
        onChange={onChange}
      />
      <main key={location.pathname} className="admin-content">
        <Outlet />
        {children}
      </main>
    
    </div>
  );
}